cb.define([], function () {
  var AA_aa_businesstypelist_VM_extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {

      var self = this;
      let gridModel = viewmodel.getGridModel();
      gridModel.on('afterSetDataSource', () => {

        const rows = gridModel.getRows();
        const actions = gridModel.getCache('actions');
        const actionsStates = [];
        rows.forEach(data => {
          // debugger
          const actionState = { };
          actions.forEach(action => {
            actionState[action.cItemName] = { visible: true };
            if (!data.stopstatus) {
              actionState["btnUnStop1"] = { visible: false };
              actionState["btnStop1"] = { visible: true };
            }
            if (data.stopstatus ) {
              actionState["btnStop1"] = { visible: false };
              actionState["btnUnStop1"] = { visible: true };

            }
            });
          actionsStates.push(actionState);
        });
        gridModel.setActionsState(actionsStates);
      });
      viewmodel.getTreeModel().setState('defaultSelectedKeys',true);
      viewmodel.on("beforeAdd", function () {

        var selectedrtys = viewmodel.getTreeModel().getSelectedNodes();
        if (selectedrtys.length==0)
        {
          cb.utils.alert('请选择单据类型','warning');
          return false;
        }
      });
      //viewmodel.on("beforeEdit", function (args) {
      //  var currentRow = viewmodel.getGridModel().getRow(args.params.params.index);

      //if(currentRow.isSystem)
      //{
      //  cb.utils.alert('预置数据不能修改','warning');
        //return false;
     // }

     // });

      viewmodel.on("beforeBatchdelete", function (args) {
        debugger
        var currentRow = viewmodel.getGridModel().getRow(args.params.params.index);
        if(currentRow.isSystem)
        {
          cb.utils.alert('默认的业务类型不能删除','warning');
         return false;
       }
      });
    }
  }
  try {
    module.exports = AA_aa_businesstypelist_VM_extend;
  } catch (error) {

  }
  return AA_aa_businesstypelist_VM_extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_businesstypelist_VM.Extend.js